import { oz } from '@weft/utils';
import { ErpMetadataSchema } from '../../../primitives/erp-metadata-schema';
import { AdvancedFilterSchema } from '../configuration/advanced-filter/advanced-filter-schema';
import { BaseConfigurationSchema } from '../configuration/base-configuration-schema';

export const NetSuiteIntegrationConfigurationSchema = BaseConfigurationSchema.extend({
  defaultReceivableAccount: oz.string().optional(),
  defaultProduct: ErpMetadataSchema.optional(),
  customersAdditionalFilters: oz.array(AdvancedFilterSchema).optional(),
}).openapi('NetSuiteIntegrationConfiguration');

export type NetSuiteIntegrationConfiguration = oz.infer<typeof NetSuiteIntegrationConfigurationSchema>;